

import { ReportService } from "../../../services/ReportsService";
import { useEffect, useState } from "react";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import { AlertService } from "../../../services/Alert";
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import Button from "../../../components/form-controls/Button";
import CustomDataTable from "../../../components/CustomDataTable";
import AddNumberModal from "./addNumberModal";
import useRequest from "../../../hooks/useRequest";


function BlacklistPage() {
    const { t, i18n } = useTranslation();
    const { account } = useCurrentAccount();
    const { call, isRequesting } = useRequest();
    const [showModalAdd, setShowModalAdd] = useState(false)
    const [list, setList] = useState([])
    const imageSrc = i18n.language === 'es' ? '/assets/img/conexion.png' : '/assets/img/conexion-en.png';

    const columnsRoot = [
        {
            name: t('reports.blacklist.id-Client'),
            sortable: false,
            center: false,
            selector: (row: { account_client_id: string; }) => row.account_client_id,
            cell: (row: any) => {
                return (
                    <div className="text-center">
                        {row.account_client_id}
                    </div>
                );
            }
        },
        {
            name: t('number'),
            sortable: false,
            center: false,
            selector: (row: { number: string; }) => row.number,
            cell: (row: any) => {
                const formatPhoneNumber = (number: string) => {
                    if (number.length !== 13) {
                        return number;
                    }
                    const countryCode = number.slice(0, 2);
                    const idCell = number.slice(2, 3);
                    const phoneNumber = number.slice(3, 13);

                    return (
                        <>
                            +{countryCode} {idCell} {phoneNumber}
                        </>
                    );
                };

                const formattedNumber = formatPhoneNumber(row.number);

                return (
                    <div className="text-left">
                        <p className="mb-1 text-nowrap">
                            <img
                                title="img-country"
                                src="/assets/vendor/flag-icon-css/flags/1x1/mx.svg"
                                className="rounded-circle me-2"
                                height="16px"
                            />
                            <span className="fs-4">{formattedNumber}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t('reports.blacklist.date-lock'),
            sortable: false,
            center: false,
            selector: (row: { date_insert: string; }) => row.date_insert,
            cell: (row: any) => {
                const fechaHora = row.date_insert.split(' ');
                const fecha = fechaHora[0];
                const hora = fechaHora[1];

                return (
                    <div className="text-left">
                        <p className="mb-1 text-nowrap">
                            <span className="h4">{t('date')}: </span> <span className="fs-4">{fecha}</span>
                        </p>
                        <p className="mb-0 text-nowrap">
                            <span className="h4">{t('hour')}: </span> <span className="fs-4">{hora}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t('reports.blacklist.ticket-id'),
            sortable: false,
            center: false,
            selector: (row: { ticket: string; }) => row.ticket,
            cell: (row: any) => {
                const content = row.ticket === 'N/A' ? (
                    <span className="badge bg-soft-info text-info fs-6">
                        <i className="bi bi-exclamation-circle"></i> {t('empty')}
                    </span>
                ) : (
                    <p className="mb-1 text-nowrap">
                        <span className="fs-4">{row.ticket}</span>
                    </p>
                );

                return (
                    <div className="text-left">
                        {content}
                    </div>
                );
            }
        },
        {
            name: t('reports.blacklist.who'),
            sortable: false,
            center: false,
            selector: (row: { who: string; }) => row.who,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <span className="badge bg-soft-primary text-dark fs-6 p-2">
                            <i className="bi bi-person-circle text-primary me-2"></i>  {row.who}
                        </span>
                    </div>
                );
            }
        },
        {
            name: t('reports.blacklist.origin'),
            sortable: false,
            center: false,
            selector: (row: { template_origin: string; }) => row.template_origin,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <span className="fs-4">{row.template_origin}</span>
                    </div>
                );
            }
        },
        {
            name: t('actions'),
            sortable: true,
            exportable: false,
            cell: (row: any) => {
                return (
                    <div className="btn-group" role="group">
                        <button type="button" className="btn btn-soft-danger btn-sm" onClick={() => deleteNumberBlack(row)}>
                            <i className="bi-trash me-2 fw-bolder"></i> {t('btn-delete')}
                        </button>
                    </div>
                )
            }
        }
    ];

    const deleteNumberBlack = async (row: any) => {
        await AlertService.warning(t('reports.blacklist.title-alert'), t('reports.blacklist.swal-msg', { number: row.number }), async () => {
            try {
                await ReportService.deleteNumber(account.id, row.number_id);
                await getList();
                AlertService.toastSuccess(t('reports.blacklist.success-msg-delete'))
            } catch (error) {
                console.error(error);
                AlertService.toastError(t('reports.blacklist.success-msg-delete'))
            }
        });
    }

    const getList = async () => {
        const { data } = await call(() => ReportService.getBlacklist(account.id));
        setList(data)
    }

    const handleCloseLinkModal = async (refresh: any) => {
        if (refresh) {
            await getList();
        }
        setShowModalAdd(false)
    }

    useEffect(() => {
        getList();
    }, [])

    return (
        <>
            <Header />
            <Aside />
            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page"><span className="breadcrumb-link" >{t("reports.reports-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">Blacklist</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-grid-1x2-fill text-primary nav-icon"></i> {t("reports.reports-title")} - Blacklist</h1>
                            </div>
                            <div className="col-sm-auto">
                                <Button className="btn btn-primary btn-sm" onClick={() => setShowModalAdd(true)}><i className="bi-plus-lg"></i>  {t("reports.blacklist.btn-add")} </Button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="card card-lg mb-3 mb-lg-5">
                                <div className="card-body text-center bg-primary bg-light">
                                    <div className="mb-3">
                                        <h3 className="text-primary mb-3">{t("reports.blacklist.title-alert")}</h3>
                                        <p dangerouslySetInnerHTML={{ __html: t('reports.blacklist.text-1') }}></p>
                                        <p dangerouslySetInnerHTML={{ __html: t('reports.blacklist.text-2') }}></p>
                                    </div>
                                    <div className="d-flex justify-content-center mb-0">
                                        <img
                                            alt="Image Description"
                                            src={imageSrc}
                                            width="270px"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <CustomDataTable
                                columns={columnsRoot}
                                data={list}
                                hideAccountsFilter
                                showExport={true}
                                isLoading={isRequesting}
                                filter={(row, term) => {
                                    if (!term) return true;

                                    return (
                                        `${row.number}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row.date_insert}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row.ticket}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row.template_origin}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row.who}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row.account_client_id}`.match(new RegExp(`${term}`, 'i'))
                                    )
                                }}
                            />
                        </div>
                    </div>
                </div>
                <AddNumberModal
                    showModalLink={showModalAdd}
                    onRequestClose={handleCloseLinkModal}
                />
                <Footer />
            </main>
        </>
    )
}
export default BlacklistPage